module.exports = __webpack_public_path__ + "7f18e0e15fa08ad234bbd5661d897a4c.jpg";